export type SomeEntity = {
    entity_type: string
    id: number
    uuid?: string
    [key: string]: unknown
    isOptimistic?: true
    updated_at?: string
}

export function isSomeEntity(entity: unknown): entity is SomeEntity {
    return typeof entity === 'object' && entity !== null && 'entity_type' in entity
}

/**
 * Checks if the given data is an array of SomeEntity objects, but only checks
 * the first element and assumes that all elements are also SomeEntity objects.
 */
export function isLikelySomeEntityArray(data: unknown): data is SomeEntity[] {
    return Array.isArray(data) && isSomeEntity(data[0])
}
